
const openBtn = document.getElementById('open-mobile-filters');
const closeBtn = document.getElementById('close-mobile-filters');
const drawer = document.getElementById('mobile-facets-drawer');
const overlay = document.getElementById('overlay');

function openDrawer() {
    drawer.classList.remove('hidden');
    overlay.classList.remove('hidden');
    // trigger sliding animation
    requestAnimationFrame(() => drawer.classList.add('open'));
}

function closeDrawer() {
    drawer.classList.remove('open');
    overlay.classList.add('hidden');
    setTimeout(() => drawer.classList.add('hidden'), 300); // match CSS transition time
}

openBtn.addEventListener('click', openDrawer);
closeBtn.addEventListener('click', closeDrawer);
overlay.addEventListener('click', closeDrawer);
